import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 1.75V9.04167M7 9.04167L4.08333 6.125M7 9.04167L9.91667 6.125M2.04167 11.375H11.9583",
		stroke: "currentColor",
		strokeWidth: 1.16667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDownload;
